<pru-modal
  [modalId]="props.modalId"
  [showClose]="props.showClose"
  [size]="props.modalSize"
  [titleBorder]="'border-bottom-0'"
  [customModalStyle]="props.customModalStyle"
  modalScrollable="true"
  (onHidden)="closeInterstitial(props.closeEvent)"
  [backdropClickClose]="true"
  [ariaLabelledBy]="'interstitialTitle'"
>
  <div modal-body>
    <div *ngIf="props.wcmContent">
      <div *ngIf="!props.consentInterstitial" [attr.data-qa]="'consentInterstitial'">
        <div class="container-fluid text-center">
            <div [innerHTML]="props.wcmContent | safeHtml"></div>
        </div>
      </div>
      <div *ngIf="props.consentInterstitial">
        <div [innerHTML]="props.wcmContent | safeHtml"></div>
      </div>
    </div>
  </div>
</pru-modal>